<template>
  <div id>
    <v-container fluid class="pt-0">
      <v-row>
        <v-col cols="12" class="pt-0">
          <v-card class>
            <v-card-title class="secondary white--text">
              About Us
              <v-spacer></v-spacer>
              <v-btn
                fab
                small
                color="success"
                class="mr-4"
                dark
                @click="save"
                v-if="modified && !loading"
              >
                <v-icon>fa-save</v-icon>
              </v-btn>
              <v-btn icon dark @click="load" :loading="loading">
                <v-icon>fa-sync</v-icon>
              </v-btn>
            </v-card-title>

            <v-container class>
              <v-row justify="center">
                <v-col cols="12">
                  <v-text-field outlined hide-details label="Video" v-model="about.video.url"></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-text-field outlined hide-details label="Title" v-model="about.title"></v-text-field>
                </v-col>
                <v-col cols="12">
                  <vue-editor v-model="about.text" />
                </v-col>
              </v-row>
              <v-row align="center" justify="center">
                <v-col cols="12" class="text-center">
                  <h2>
                    Members
                    <v-btn fab x-small color="primary" @click="addMember" class="ml-2">
                      <v-icon x-small>fa-plus</v-icon>
                    </v-btn>
                  </h2>
                </v-col>
                <v-col cols="12" md="4" lg="4" xl="3" v-for="(member,i) in about.members" :key="i">
                  <v-card>
                    <v-container class="pa-4 grey lighten-3">
                      <image-picker :tile="true" :size="150" v-model="member.picture"></image-picker>
                    </v-container>

                    <v-container>
                      <v-text-field
                        outlined
                        hide-details
                        label="Name"
                        v-model="member.name"
                        class="mt-4"
                      ></v-text-field>
                      <v-textarea
                        outlined
                        hide-details
                        label="Bio"
                        v-model="member.bio"
                        class="mt-4"
                      ></v-textarea>
                      <v-text-field
                        outlined
                        hide-details
                        label="Profile"
                        v-model="member.profile"
                        class="mt-4"
                      ></v-text-field>
                    </v-container>

                    <v-card-actions class="grey lighten-3">
                      <v-spacer></v-spacer>
                      <v-btn text color="red" @click="removeMember(member)">Remove</v-btn>
                      <v-spacer></v-spacer>
                    </v-card-actions>
                  </v-card>
                </v-col>
              </v-row>
            </v-container>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>
<script>
import imagePicker from "@/components/admin/image-picker";
export default {
  name: "",
  components: {
    imagePicker
  },
  data: () => ({
    about: {
      video: {}
    },
    loading: false,
    modified: false
  }),
  watch: {
    about: {
      handler: function() {
        this.modified = true;
      },
      deep: true
    }
  },
  computed: {},
  created() {
    this.load();
  },
  methods: {
    addMember() {
      this.about.members.push({
        bio: "",
        name: "",
        picture: null,
        profile: ""
      });
    },
    removeMember(member) {
      if (!confirm("Delete member ?")) {
        return;
      }
      this.about.members = this.about.members.filter(m => {
        return m !== member;
      });
    },
    async load() {
      this.loading = true;
      let website = await this.$api(`/admin/website`);
      this.about = website.about;
      setTimeout(
        function() {
          this.modified = false;
        }.bind(this),
        100
      );
      this.loading = false;
    },
    async save() {
      this.loading = true;
      await this.$api({
        method: "PATCH",
        url: `/admin/website`,
        data: {
          about: this.about
        }
      });
      setTimeout(
        function() {
          this.modified = false;
        }.bind(this),
        100
      );
      this.loading = false;
    }
  },
  async beforeRouteLeave(to, from, next) {
    if (this.modified) {
      const answer = window.confirm(
        "Do you really want to leave? you have unsaved changes!"
      );
      if (answer) {
        next();
      } else {
        next(false);
      }
    } else {
      next();
    }
  }
};
</script>
<style lang="scss" scoped>
</style>
